<template>
    <div class="container">
        <div class="container-item">
            <div class="container-title--en">ABOUT US</div>
            <div class="container-title--zh">关于我们</div>

            <b-container>
                <b-row class="abouts">
                    <b-col
                        v-for="(item, idx) in abouts"
                        :key="idx"
                        sm="12"
                        md="4"
                        xl="4"
                    >
                        <div class="about-item">
                            <img
                                class="about-img"
                                :src="
                                    require(`@/assets/images/abouts/${idx +
                                        1}.png`)
                                "
                            />
                            <div class="about-msg">
                                <div class="about-msg__title">
                                    {{ item.title }}
                                </div>
                                <div class="about-msg__divider"></div>
                                <div class="about-msg__content">
                                    {{ item.content }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <!-- <div class="container-item">
            <div class="container-title--en">SUCCESSFUL CASES</div>
            <div class="container-title--zh">成功案例</div>

            <b-container class="cases">
                <b-row class="case-row">
                    <b-col
                        v-for="(item, idx) in cases[0]"
                        :key="idx"
                        cols="6"
                        sm="6"
                        md="3"
                        xl="3"
                        class="case-col"
                    >
                        <div class="case-item">
                            <img
                                class="case-img"
                                :src="
                                    require(`@/assets/images/cases/${idx +
                                        1}.png`)
                                "
                            />
                            <span class="case-title">
                                {{item.name}}
                            </span>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="justify-content-md-center case-row">
                    <b-col
                        v-for="(item, idx) in cases[1]"
                        :key="idx"
                        cols="6"
                        sm="6"
                        md="3"
                        xl="3"
                        class="case-col"
                    >
                        <div class="case-item">
                            <img
                                class="case-img"
                                :src="
                                    require(`@/assets/images/cases/${idx +
                                        5}.png`)
                                "
                            />
                            <span class="case-title">
                                {{item.name}}
                            </span>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div> -->

        <!-- <div class="container-item">
            <div class="container-title--en">BUSINESS PARTNER</div>
            <div class="container-title--zh">合作伙伴</div>

            <div class="partner">
                <b-container>
                    <b-row>
                        <b-col
                            ><img
                                class="partner-img"
                                src="@/assets/images/partner.png"/></b-col
                    ></b-row>
                </b-container>
            </div>
        </div> -->
    </div>
</template>

<script>
import abouts from "@/config/abouts";
import cases from "@/config/cases";

export default {
    data() {
        return {
            abouts,
            cases
        };
    }
};
</script>

<style lang="less">
@import "./index.less";
</style>
